"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIconListItem = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const createSlot_1 = require("./createSlot");
const createIconListItem = ({ condition, icons, isSelected, onClick, slotImagePath, text, width, x, y, }) => {
    const hudElementReferences = [];
    const buttonIDs = [];
    const labelIDs = [];
    hudElementReferences.push((0, createSlot_1.createSlot)({
        condition,
        icons,
        imagePath: slotImagePath,
        isSelected,
        x,
        y,
    }));
    labelIDs.push((0, pixel_pigeon_1.createLabel)({
        color: retrommo_types_1.Color.White,
        coordinates: {
            condition,
            x: x + 20,
            y: y + 5,
        },
        horizontalAlignment: "left",
        maxLines: 1,
        maxWidth: width - 18,
        size: 1,
        text,
    }));
    buttonIDs.push((0, pixel_pigeon_1.createButton)({
        coordinates: {
            condition,
            x,
            y,
        },
        height: 16,
        onClick,
        width,
    }));
    return (0, pixel_pigeon_1.mergeHUDElementReferences)([
        {
            buttonIDs,
            labelIDs,
        },
        ...hudElementReferences,
    ]);
};
exports.createIconListItem = createIconListItem;
